"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchIncomeReport = MatchIncomeReport;
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_jss_1 = require("react-jss");
const BalanceIcon_1 = require("~/components/ui/icon/BalanceIcon");
const useStyles = (0, react_jss_1.createUseStyles)({
    root: {
        "display": "flex",
        "flexDirection": "column",
        "justifyContent": "center",
        "gap": "8px",
        "@media (orientation: portrait) and (max-width: 430px)": {
            gap: "4px",
        },
    },
    total: {
        "display": "flex",
        "flexDirection": "row",
        "alignItems": "center",
        "justifyContent": "center",
        "gap": "24px",
        "fontSize": "24px",
        "@media (orientation: portrait) and (max-width: 430px)": {
            fontSize: "16px",
            gap: "16px",
        },
    },
    incomeTable: {
        "display": "grid",
        "gridTemplateColumns": "repeat(2, 1fr)",
        "gridRowGap": "4px",
        "gridColumnGap": "16px",
        "fontSize": "16px",
        "& > *:nth-child(odd)": {
            textAlign: "right",
            color: "#d4d4d4",
        },
        "@media (orientation: portrait) and (max-width: 430px)": {
            fontSize: "12px",
        },
    },
});
function MatchIncomeReport({ rewards, className }) {
    const styles = useStyles();
    const { rewardMoney: { total, base, winBonus, streakBonus, interest }, } = rewards;
    return (React.createElement("div", { className: (0, classnames_1.default)(styles.root, className) },
        React.createElement("div", { className: styles.total },
            React.createElement(BalanceIcon_1.BalanceIcon, { amount: total }),
            React.createElement("span", null, "earned")),
        React.createElement("div", { className: styles.incomeTable },
            React.createElement("div", null, "base"),
            React.createElement("div", null,
                React.createElement(BalanceIcon_1.BalanceIcon, { amount: base })),
            React.createElement("div", null, "win bonus"),
            React.createElement("div", null,
                React.createElement(BalanceIcon_1.BalanceIcon, { amount: winBonus })),
            React.createElement("div", null, "streak bonus"),
            React.createElement("div", null,
                React.createElement(BalanceIcon_1.BalanceIcon, { amount: streakBonus })),
            React.createElement("div", null, "interest (10%)"),
            React.createElement("div", null,
                React.createElement(BalanceIcon_1.BalanceIcon, { amount: interest })))));
}
